/**
 * EmptyWidget — een bewust lege widget, handig als opvulling/spacer in de layout.
 * Schaalbaar 1/2/3 breed en in alle hoogtes (default auto). Rendert geen inhoud;
 * in normale weergave is de kaart transparant (zie WidgetShell `blank`), in
 * edit-modus krijgt 'ie de gewone chrome zodat je 'm kunt schalen/verplaatsen.
 */
import React from 'react';
import { Box } from '@mui/material';

export default function EmptyWidget() {
  // minHeight geeft de 'auto'-variant een minimale aanwezigheid.
  return <Box sx={{ minHeight: 64 }} />;
}
